<template>
  <div>
    <el-tabs type="border-card">
    <el-row>
      <el-col :span="24">
        <div style="text-align:left" class="title">统计信息</div>
      </el-col>
    </el-row>
      <el-scrollbar height="calc(100vh - 50px - 36px - 32px)">
        <el-collapse v-model="activeNames" accordion>
          <div v-if="this.rootNavigateId.idx == 1">
            <el-collapse-item
                v-for="item in dataStatistics[0]"
                :key="item.name"
                :title="item.name"
                :name="item.name"
            >
              <el-table
                  :data="item.data"
                  style="width: 100%">
                <el-table-column
                    prop="name"
                    label="数据项"
                    width="120">
                </el-table-column>
                <el-table-column
                    prop="cnt"
                    label="井数"
              width="75">
            <template #default="scope">
            <span style="cursor:pointer;color:blue" @click="handleEdit(scope.$index, scope.row)">
              {{ scope.row.cnt }}
            </span>
            </template>
                </el-table-column>
              </el-table>
            </el-collapse-item>
          </div>
          <div v-if="this.rootNavigateId.idx == 2">
            <el-collapse-item
                v-for="item in dataStatistics[1]"
                :key="item.name"
                :title="item.name"
                :name="item.name"
            >
              <el-collapse accordion>
                <el-collapse-item
                    v-for="it in item.data"
                    :key="it.name"
                    :title="it.name"
                    :name="it.name"
                >
                  <el-table
                      :data="it.data"
                      style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="数据项"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="cnt"
                        label="个数"
                        width="75">
                      <template #default="scope">
                        <span style="cursor:pointer;color:blue" @click="handleEdit(scope.$index, scope.row)">{{scope.row.cnt}}</span>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-collapse-item>
              </el-collapse>
            </el-collapse-item>
          </div>
        </el-collapse>
        <el-collapse v-model="activeNames" accordion>
          <el-collapse-item title="指标安排统计" name="9" v-if="this.rootNavigateId.idx == 3">
            <el-table
                :data="gqData"
                style="width: 100%">
              <el-table-column
                  prop="name"
                  label="数据项"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="cnt"
                  label="个数"
                  width="75">
                <template #default="scope">
                  <span style="cursor:pointer;color:blue"
                        @click.stop="drawingsClick(scope.row,scope.column)">{{ scope.row.cnt }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
          <el-collapse-item title="工作报告统计" name="9" v-if="this.rootNavigateId.idx == 4">
            <el-table
                :data="gqData"
                style="width: 100%">
              <el-table-column
                  prop="name"
                  label="数据项"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="cnt"
                  label="个数"
                  width="75">
                <template #default="scope">
                  <span style="cursor:pointer;color:blue"
                        @click.stop="drawingsClick(scope.row,scope.column)">{{ scope.row.cnt }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-scrollbar>
  </el-tabs>
    <!-- 钻取table-->
    <div v-dialogDrag>
      <dialog-ex
          v-model="drilltableVisible"
          :title="drillDlgTitle"
          width="90%"
          @closeMsg="drilltableVisible = false"
          :is-footer="true"
      >
        <template #body>
          <el-button size="mini" type="primary" @click.stop="exportTable()" style="margin-bottom: 10px">导出</el-button>
          <tableControl
              ref="drillControl"
              v-show="viewDisplay"
              :selectable="selectable"
              :template-info="templateInfo"
              :grid-cfg="gridCfg"
              v-bind:select-column-status-changed="onSelectColumnStatusChanged"
          >
          </tableControl>
          <el-pagination
              :page-sizes="[20, 50, 100, 200]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="dataNum"
              :page-count="pageCount"
              :current-page="currentPage"
              @size-change="tablesizeChange"
              @current-change="currenttableChange"
              style="text-align: right"
              v-if="pagination"
              v-show="viewDisplay"
          >
          </el-pagination>
        </template>

        <template #footer>
          <span class="dialog-footer">
              <el-button type="primary" @click="drilltableVisible = false">退出</el-button>
            <!--              <el-button type="primary">确认</el-button>-->
          </span>
        </template>
      </dialog-ex>
    </div>

    <div v-dialogDrag>
    <dialog-ex
        v-model="drawingsDialogVisible"
        :title="drillDlgTitle"
        width="90%"
        @closeMsg="drawingsDialogVisible = false"
        :is-footer="true"
    >
      <template #body>
        <el-pagination
            :page-sizes="[20, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dataNum"
            :page-count="pageCount"
            :current-page="currentPage"
            @size-change="sizeChange"
            @current-change="currentChange"
            style="text-align: right"
            v-if="pagination"
            v-show="viewDisplay"
        >
        </el-pagination>
        <tableControl
            ref="tableControl"
            v-show="viewDisplay"
            :selectable="selectable"
            :template-info="templateInfo"
            :grid-cfg="gridCfg"
            v-bind:select-column-status-changed="onSelectColumnStatusChanged"
        >
        </tableControl>
      </template>

      <template #footer>
          <span class="dialog-footer">
              <el-button type="primary" @click="drawingsDialogVisible = false">退出</el-button>
            <!--              <el-button type="primary">确认</el-button>-->
          </span>
      </template>
    </dialog-ex>
  </div>
  </div>
</template>

<script>
import axios from "axios";
// import {ref} from "vue";
import DialogEx from "@/components/dialogEx";
import tableControl from '@/components/tableControl.vue';
import {_exportTable02} from "../../../public/static/js/util";
export default {
  name: 'StatisticsWindow',
  components:{
    DialogEx,
    tableControl
  },
  data() {
    return {
      drillDlgTitle:"详细信息",
      curCheckedBlk:"",
      curBlkTypeId:"",
      curDrillAppId:"",
      curDrillFlID:"",
      viewDisplay:true,//分页
      pagination:true,//分页
      drilltableVisible: false,
      drawingsDialogVisible: false,
      dataNum:10,
      total: 15,//分页
      pageCount:1,//总页数
      currentPage: 1,//当前页数
      pageSize: 20,//每页所展示的数量
      drawingsHeader:[],//图列表头
      drawingsData:[],//图列数据
      activeNames: [],
      drilltable: [],
      drilltableHeader: [],
      tableData: [
        {
          name: '单井基础数据',
          cnt: '10'
        }, {
          name: '井斜数据',
          cnt: '10'
        }, {
          name: '钻井地质数据',
          cnt: '10'
        }, {
          name: '射孔数据',
          cnt: '10'
        }],
      jcData:[],
      zyData:[],
      hyData:[],
      ytqkData:[],
      docData:[],
      tjData:[],
      gqData:[],
      prodData: [
        {
          name: '当日采油井',
          cnt: '0'
        }, {
          name: '当日注气井',
          cnt: '0'
        }, {
          name: '当日注水井',
          cnt: '0'
        }, {
          name: '当月采油井',
          cnt: '0'
        }, {
          name: '当月采气井',
          cnt: '0'
        }, {
          name: '当月注气井',
          cnt: '0'
        }, {
          name: '当月注水井',
          cnt: '0'
        }, {
          name: '当年新投采油井',
          cnt: '0'
        }, {
          name: '当年新投采气井',
          cnt: '0'
        }, {
          name: '当年措施采油井',
          cnt: "0"
        }, {
          name: '当年措施采气井',
          cnt: "0"
        }],
      dataStatistics:[]//统计数据
    }
  },
  // setup () {
  //   let drawingsDialogVisible = ref(false)
  //   let drilltableVisible = ref(false)
  //   const closeDrillTableDialog = () => {
  //     drilltableVisible.value = false
  //   }
  //
  //   const closeDrawingsDialog = () => {
  //     drawingsDialogVisible.value = false;
  //     console.log(drawingsDialogVisible)
  //   }
  //   return {
  //     drawingsDialogVisible,
  //     drilltableVisible,
  //     closeDrawingsDialog,
  //     closeDrillTableDialog
  //   }
  // },
  methods: {
    //打开绘图信息
    drawingsClick(row, column){
      if(row.cnt==0){
        return
      }
      console.log(row, column)
      this.drillDlgTitle = row.name+"详细信息";
      let user_id = "0000001";
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      // let curUserId = "";
      let curUserEmplyeeId = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // user_id = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
      }
      let blkTypeId = localStorage.getItem("blockType");
      if (blkTypeId == null || blkTypeId==undefined) blkTypeId = "02";
      this.curDrillAppId = row.pageid;
      if(this.curDrillAppId == undefined)
        return;
      this.curDrillFlID = row.flid;
      if(this.curDrillFlID == undefined)
        this.curDrillFlID = "";
      let _this =this;	
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongridheader", {
        params: {
          user_id: user_id,
          app_id: this.curDrillAppId
        }
      }).then(res=>{
        console.log(res.data.header);
        this.drawingsHeader=res.data.header;
        axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongriddata", {
          user_id: user_id,
          user_empid: curUserEmplyeeId,
          app_id: this.curDrillAppId,
          blkTypeID: blkTypeId,
          checkedBlk: this.curCheckedBlk,
          queryFilter: [],
          flId:this.curDrillFlID,//分类id(成果管理需要)
          total:true,//是否需要返回总页数
          page:1,//当前页码从1开始
          size:10//一页显示记录数
        }).then(ress=>{
          console.log(ress.data.data);
          this.drawingsData=ress.data.data;
          this.dataNum=this.drawingsData.length;
          this.drawingsDialogVisible=true;
          this.$nextTick(()=>{
            console.log(_this.$refs.tableControl)
          },100)

          let json ={};
          json.header = this.drawingsHeader;
          json.data = this.drawingsData;
          json.clickNum = 0;
          json.xxoo = 0;
          json.isFixed = false;
          json.name = "";
          json.operation = false;
          this.$nextTick(()=>{
            this.$refs.tableControl.getData(json)
          },100)
        })

      })

    },
    //静态信息点击
    handleEdit(index, row) {
      console.log(index,row)
      this.curDrillAppId = "";
      this.curDrillFlID = "";
      if(row.cnt<=0)
        return;
      // 数据在row 里面
      this.drillDlgTitle = row.name;
      let user_id = "0000001";
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      // let curUserId = "";
      let curUserEmplyeeId = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // user_id = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
      }
      this.curDrillAppId = row.pageid;
      if(this.curDrillAppId == undefined)
        return;
      this.curDrillFlID = row.flid;
      if(this.curDrillFlID == undefined)
        this.curDrillFlID = "";

      let drillJH="";
      let wells = this.$store.state.wellData;
      if (this.$store.state.wellDataHome.length != 0)
        wells = this.$store.state.wellDataHome;
      //用户第一次打开网站 缓存：localStorage为空
      if (wells!=null && wells!=undefined && wells.length!=4){
        drillJH=wells[0];//区块，或单井名称列表
        if (wells.length==3){
          drillJH=wells[1].toLocaleString();
        }
      }
      console.log("drillJH:",drillJH);

      let _this =this;
      axios.get(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongridheader", {
        params: {
          user_id: user_id,
          app_id: this.curDrillAppId
        }
      }).then(res=>{
        console.log("checked header？",res.data.template.checked);
        console.log("header",res.data.header);
        let checked = res.data.template.checked;
        let header = res.data.header;
        this.drilltableHeader=[];
          // 通过checked 筛选选中表头
          for(let i=0; i<checked.length;i++){
            this.drilltableHeader.push(header[checked[i]])
          }
        axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/commongriddata", {
          user_id: user_id,
          user_empid: curUserEmplyeeId,
          app_id: this.curDrillAppId,
          drillJH: drillJH,
          flId:this.curDrillFlID,//分类id(成果管理需要)
          checkedBlk: this.curCheckedBlk,
          blkTypeID: this.curBlkTypeId,
          queryFilter: [],
          total:true,//是否需要返回总页数
          page:1,//当前页码从1开始
          size:this.pageSize//一页显示记录数
        }).then(ress=>{
          console.log(ress.data.data);
          this.drilltable=ress.data.data;
          this.dataNum=ress.data.totalElements;
          this.drilltableVisible=true;
          this.$nextTick(()=>{
            console.log(_this.$refs.drillControl)
          },100)
          console.log("dataNum能获取到吗!!!!!!",ress.data)
          let json ={};
          json.header = this.drilltableHeader;
          json.data = this.drilltable;
          json.clickNum = 0;
          json.xxoo = 0;
          json.isFixed = false;
          json.name = "";
          json.operation = false;
          this.$nextTick(()=>{
            this.$refs.drillControl.getData(json)
          },100)
        })

      })
      console.log("看看index and row!!!!!",index, row);

    },
    //信息统计
    doStatistics(checkedBlock){
      //todo 暂时跳过
      let as=true;
      if (as){
        return
      }

      this.curDrillAppId = "";
      this.curDrillFlID = "";
      let jsonCheckedBlk;
      try {
        jsonCheckedBlk = JSON.parse(checkedBlock);
      } catch {
        jsonCheckedBlk = JSON.parse("{}");
      }
      let strCheckedBlkId = "";
      let keyIdx = 0;
      for (let key in jsonCheckedBlk) {
        if (keyIdx > 0) {
          strCheckedBlkId += ",";
        }
        strCheckedBlkId += key;
        keyIdx += 1;
      }
      this.curCheckedBlk = strCheckedBlkId;

      let blkTypeId = localStorage.getItem("blockType");
      if (blkTypeId == null || blkTypeId==undefined) blkTypeId = "02";
      this.curBlkTypeId = blkTypeId; //区块类型
      console.log("11111111111", checkedBlock);
      //prodData
      // axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/wellCount", {blkTypeID:blkTypeId,checkedBlock:checkedBlock})
      //     .then(res => {
      //   if (res.status === 200) {
      //     console.log("res..:",res)
      //     this.prodData = res.data.prodData;
      //   }
      // }).catch((err) => {
      //   console.log("ERRRR:",err)
      // });
      //Doc
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/businessdata/uploadResultCnt", {blkTypeID:blkTypeId,checkedBlock:checkedBlock, sclx:"Doc"})
          .then(res => {
            if (res.status === 200) {
              this.docData = res.data.content;
              console.log(res)
            }
          }).catch((err) => {
        console.log(err)
      });

      //静态信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"Static",checkedBlock:strCheckedBlkId})
          .then(res => {
            if (res.status === 200) {
              this.tableData = res.data.content;
              console.log("静态信息返回数据!",res)
            }
          }).catch((err) => {
        console.log(err)
      });

      //生产信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"Dev",checkedBlock:strCheckedBlkId})
          .then(res => {
            if (res.status === 200) {
              this.prodData = res.data.content;
              console.log(res)
            }
          }).catch((err) => {
        console.log(err)
      });
      //检测信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"jc",checkedBlock:strCheckedBlkId})
          .then(res => {
            if (res.status === 200) {
              this.jcData = res.data.content;
            }
          }).catch((err) => {
        console.log(err)
      });

      //作业信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"zy",checkedBlock:strCheckedBlkId})
          .then(res => {
            if (res.status === 200) {
              this.zyData = res.data.content;
            }
          }).catch((err) => {
        console.log(err)
      });

      // // 化验信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"hy",checkedBlock:strCheckedBlkId})
          .then(res => {
            if (res.status === 200) {
              this.hyData = res.data.content;
            }
          }).catch((err) => {
        console.log(err)
      });

      // // 油田区块信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"ytqk",checkedBlock:strCheckedBlkId})
          .then(res => {
            if (res.status === 200) {
              this.ytqkData = res.data.content;
            }
          }).catch((err) => {
        console.log(err)
      });

      //Tj
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/businessdata/uploadResultCnt", {blkTypeID:blkTypeId,checkedBlock:checkedBlock, sclx:"Tj"})
          .then(res => {
            if (res.status === 200) {
              this.tjData = res.data.content;
              console.log(res)
            }
          }).catch((err) => {
        console.log(err)
      });
      //Gq
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/businessdata/uploadResultCnt", {blkTypeID:blkTypeId,checkedBlock:checkedBlock, sclx:"Gq"})
          .then(res => {
            if (res.status === 200) {
              this.gqData = res.data.content;
              console.log(res)
            }
          }).catch((err) => {
        console.log(err)
      });
    },
    //初始统计
    initStatics(){
      this.curDrillAppId = "";
      this.curCheckedBlk = "";
      this.curDrillFlID = "";
      this.curBlkTypeId = "";
      //Doc
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/businessdata/uploadResultCnt", {sclx:"Doc"})
          .then(res => {
            if (res.status === 200) {
              this.docData = res.data.content;
              console.log(res)
            }
          }).catch((err) => {
        console.log(err)
      });

      //检测信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"jc"})
          .then(res => {
            if (res.status === 200) {
              this.jcData = res.data.content;
            }
          }).catch((err) => {
        console.log(err)
      });

      //作业信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"zy"})
          .then(res => {
            if (res.status === 200) {
              this.zyData = res.data.content;
            }
          }).catch((err) => {
        console.log(err)
      });

      //化验信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"hy"})
          .then(res => {
            if (res.status === 200) {
              this.hyData = res.data.content;
            }
          }).catch((err) => {
        console.log(err)
      });

      //油田区块信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"ytqk"})
          .then(res => {
            if (res.status === 200) {
              this.ytqkData = res.data.content;
            }
          }).catch((err) => {
        console.log(err)
      });
     //生产信息
     //  axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"Dev"})
     //      .then(res => {
     //        if (res.status === 200) {
     //          this.prodData = res.data.content;
     //          console.log(res)
     //        }
     //      }).catch((err) => {
     //    console.log(err)
     //  });

      //静态信息
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/statisResultCnt", {sclx:"Static"})
          .then(res => {
            if (res.status === 200) {
              this.tableData = res.data.content;
              console.log("静态信息返回数据!",res)
            }
          }).catch((err) => {
        console.log(err)
      });
      //Tj
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/businessdata/uploadResultCnt", {sclx:"Tj"})
          .then(res => {
            if (res.status === 200) {
              this.tjData = res.data.content;
              console.log(res)
            }
          }).catch((err) => {
        console.log(err)
      });
      //Gq
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/businessdata/uploadResultCnt", {sclx:"Gq"})
          .then(res => {
            if (res.status === 200) {
              this.gqData = res.data.content;
              console.log(res)
            }
          }).catch((err) => {
        console.log(err)
      });
    },

    tablesizeChange(pageSize){
      let num = this.dataNum/pageSize;
      this.pageCount=Math.ceil(num);
      this.pageSize = pageSize;
      let user_id = "0000001";
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      // let curUserId = "";
      let curUserEmplyeeId = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // user_id = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
      }

      let drillJH="";
      let wells = this.$store.state.wellData;
      if (this.$store.state.wellDataHome.length != 0)
        wells = this.$store.state.wellDataHome;
      //用户第一次打开网站 缓存：localStorage为空
      if (wells!=null && wells!=undefined && wells.length!=4){
        drillJH=wells[0];//区块，或单井名称列表
        if (wells.length==3){
          drillJH=wells[1].toLocaleString();
        }
      }
      console.log("drillJH:",drillJH);

      // console.log("能获取到吗appid吗?",this.curDrillAppId)
      axios.post(process.env.VUE_APP_SERVER+ "/dataprovider/systemdata/commongriddata",{
        user_id:user_id,
        user_empid: curUserEmplyeeId,
        app_id:this.curDrillAppId,
        drillJH: drillJH,
        flId:this.curDrillFlID,//分类id(成果管理需要)
        checkedBlk: this.curCheckedBlk,
        blkTypeID: this.curBlkTypeId,
        queryFilter:[],//查询条件
        total:false,//是否需要返回总页数
        page:this.currentPage,//当前页码从1开始
        size:this.pageSize//一页显示记录数
      }).then(res=>{
        console.log("点击分页",res.data.data)
        this.drilltable=res.data.data;
        let json ={};
        json.clickNum=0;
        json.header=this.drilltableHeader;
        json.name=this.name;
        json.operation=false;
        json.xxoo=0;
        json.data=this.drilltable;
        //this.form.dataNum=res.data.data.length;
        this.$refs.drillControl.getData(json);
      }).catch(err=>{
        console.log(err)
      })

    },
    sizeChange(pageSize){
      console.log(pageSize)
      let num = this.dataNum/pageSize;
      this.pageCount=Math.ceil(num);
      this.pageSize = pageSize;
      // console.log(this.pageCount)
      // console.log(this.queryFilter );
      let user_id = "0000001";
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      // let curUserId = "";
      let curUserEmplyeeId = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // user_id = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
      }
      if(this.curDrillAppId == undefined)
        return;
      axios.post(process.env.VUE_APP_SERVER+ "/dataprovider/systemdata/commongriddata",{
        user_id:user_id,
        user_empid: curUserEmplyeeId,
        app_id:this.curDrillAppId,
        flId:this.curDrillFlID,//分类id(成果管理需要)
        checked:this.choseHeader,
        checkedBlk: this.curCheckedBlk,
        blkTypeID: this.curBlkTypeId,
        queryFilter:[],//查询条件
        total:false,//是否需要返回总页数
        page:this.currentPage,//当前页码从1开始
        size:this.pageSize//一页显示记录数
      }).then(res=>{
        console.log("点击分页",res.data.data)
        this.drawingsData=res.data.data;
        let json ={};
        json.clickNum=0;
        json.header=this.drawingsHeader;
        json.name=this.name;
        json.operation=false;
        json.xxoo=0;
        json.data=this.drawingsData;
        //this.form.dataNum=res.data.data.length;
        this.$refs.tableControl.getData(json);
      }).catch(err=>{
        console.log(err)
      })
    },
    //点击第几页
    currenttableChange(currentPage){
      console.log(currentPage)
      this.currentPage=currentPage;
      let user_id = "0000001";
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      // let curUserId = "";
      let curUserEmplyeeId = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // user_id = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
      }
      if(this.curDrillAppId == undefined)
        return;

      let drillJH="";
      let wells = this.$store.state.wellData;
      if (this.$store.state.wellDataHome.length != 0)
        wells = this.$store.state.wellDataHome;
      //用户第一次打开网站 缓存：localStorage为空
      if (wells!=null && wells!=undefined && wells.length!=4){
        drillJH=wells[0];//区块，或单井名称列表
        if (wells.length==3){
          drillJH=wells[1].toLocaleString();
        }
      }
      console.log("drillJH:",drillJH);

      axios.post(process.env.VUE_APP_SERVER+ "/dataprovider/systemdata/commongriddata",{
        user_id:user_id,
        user_empid: curUserEmplyeeId,
        app_id:this.curDrillAppId,
        drillJH: drillJH,
        flId:this.curDrillFlID,//分类id(成果管理需要)
        checkedBlk: this.curCheckedBlk,
        blkTypeID: this.curBlkTypeId,
        queryFilter:[],//查询条件
        total: false,//是否需要返回总页数
        page:this.currentPage,//当前页码从1开始
        size:this.pageSize//一页显示记录数
      }).then(res=>{
        console.log("点击分页",res)
        this.drawingsData=res.data.data;
        let json ={};
        json.clickNum=0;
        json.header=this.drilltableHeader;
        json.name="";
        json.operation=false;
        json.xxoo=0;
        json.data=res.data.data;
        //this.form.dataNum=res.data.totalElements;
        console.log(json);
        this.$refs.drillControl.getData(json);
      }).catch(err=>{
        console.log(err)
      })

    },

    //点击第几页
    currentChange(currentPage){
      console.log(currentPage)
      this.currentPage=currentPage;
      let user_id = "0000001";
      let userInfoSession = localStorage.getItem("lyqtUserInfo");
      if (userInfoSession == null) userInfoSession = {};
      // let curUserId = "";
      let curUserEmplyeeId = "";
      if (userInfoSession.length > 0) {
        let jsonUserInfo = JSON.parse(userInfoSession);
        // user_id = jsonUserInfo.userId;
        curUserEmplyeeId = jsonUserInfo.employeeId;
      }
      if(this.curDrillAppId == undefined)
        return;
      axios.post(process.env.VUE_APP_SERVER+ "/dataprovider/systemdata/commongriddata",{
        user_id:user_id,
        user_empid: curUserEmplyeeId,
        app_id:this.curDrillAppId,
        flId:this.curDrillFlID,//分类id(成果管理需要)
        checked:this.choseHeader,
        checkedBlk: this.curCheckedBlk,
        blkTypeID: this.curBlkTypeId,
        queryFilter:[],//查询条件
        total: false,//是否需要返回总页数
        page:this.currentPage,//当前页码从1开始
        size:this.pageSize//一页显示记录数
      }).then(res=>{
        console.log("点击分页",res)
        this.drawingsData=res.data.data;
        let json ={};
        json.clickNum=0;
        json.header=this.drawingsHeader;
        json.name="";
        json.operation=false;
        json.xxoo=0;
        json.data=res.data.data;
        //this.form.dataNum=res.data.totalElements;
        console.log(json);
        this.$refs.tableControl.getData(json);
      }).catch(err=>{
        console.log(err)
      })

    },

    //todo 信息统计
    informationStatistics(){
      let checkedBlk = localStorage.getItem("checkedBlock");
      // console.log("bbbbb-----checkedBlk:",checkedBlk);
      if (checkedBlk == null|| checkedBlk==undefined) checkedBlk = "{}";
      if (checkedBlk.length > 0) {
        let jsonCheckedBlk = JSON.parse(checkedBlk);
        this.curCheckedBlk = "";
        for (let key in jsonCheckedBlk) {
          if(this.curCheckedBlk.length >0) {
            this.curCheckedBlk += ",";
          }
          this.curCheckedBlk += key;
        }
        let blkTypeId = localStorage.getItem("blockType");
        if (blkTypeId == null || blkTypeId==undefined) blkTypeId = "02";
        this.curBlkTypeId = blkTypeId; //区块类型
      }
      let wells = this.$store.state.wellData;
      if (this.$store.state.wellDataHome.length != 0)
        wells = this.$store.state.wellDataHome;
      if (wells.length == 0)
        wells = JSON.parse(localStorage.getItem("wells"));
      //用户第一次打开网站 缓存：localStorage为空
      if (wells==null || wells==undefined)
        return;
      //wells信息分为区块，多井和单井，结构不一样，只添加区块数据
      let statisticNames=wells[0];//区块，或单井名称列表
      let statisticType="well";//区块，单井类别
      if (wells.length==3){
        statisticNames=wells[1].toLocaleString();
      }
      if (wells.length==4){
        statisticNames=wells[1].toLocaleString();
        statisticType="block";
      }
      let blockType = localStorage.getItem("blockType");//获取研究对象类型
      if (blockType == null || blockType==undefined) blockType = "02";
      axios.post(process.env.VUE_APP_SERVER + "/dataprovider/systemdata/informationStatistics",{
        statisticNames,
        statisticType,
        blockType
      }).then(res=>{
        // console.log(res);
        this.dataStatistics=res.data.content;
        console.log("统计数据：",this.dataStatistics);
      }).catch(err=>{
        console.log(err);
      })
    },
    //报表文件导出函数
    exportTable() {
      let excelName = this.drillDlgTitle!=null ? this.drillDlgTitle : "统计数据表";
      var exportTableList = document.getElementsByClassName("bueatyScroll");
      let len=exportTableList.length;
      let exportTable=exportTableList[len-1];
      //使用el-table的fixed属性固定列，elementui的实现方式：创建了两个tabledom，通过一个隐藏一个显示来实现交互效果。导出整个el-table 就会将两个div内的table都导出，导致数据重复
      var fix=exportTable.querySelector('.el-table__fixed');
      //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除
      if (fix)
        exportTable=exportTable.removeChild(fix);
      _exportTable02(excelName,exportTable);
    },
  },
  mounted() {
    // this.initStatics();
    this.informationStatistics();
  },
  props: {
    rootNavigateId: {
      default: {}
    }
  },
  // watch: {
  //   rootNavigateId() {
  //     console.log("rootID:", this.rootNavigateId.idx);
  //   }
  // }
  computed:{
    //计算单井数据变化
    wellDatas(){
      return this.$store.getters.getWellData;
    },
    //计算单井数据变化
    wellDataHomes(){
      return this.$store.getters.getWellDataHome;
    },
  },
  watch:{
    //监听单井数据变化
    wellDatas(){
      this.informationStatistics();
    },
    //监听首页检索数据变化
    wellDataHomes(){
      // console.log(this.$store.state.wellDataHome)
      console.log("首页检索：",this.wellDataHomes)
      if (this.wellDataHomes.length==0)
        return;
      this.informationStatistics();
    },
  }
}
</script>
<style>
.title {
  font-size: 20px;
  font-family: 微软雅黑;
  font-weight: bold;
}

.zq {
  color: blue;
}
</style>